@if (!pageLoaded) {
<epic-loader-content animation="square" />
} @else {
<div
	class="order-add-new"
	[style.opacity]="pageLoaded ? 1: 0">
	<div class="order-add-new__list">
		<div class="order-add-new__item">
			<div class="order-add-new__title order-add-new__header">
				<div class="font__heading-3 font-weight__semibold">{{ textBasicData }}</div>
				<div>
					<epic-icon-button
						(click)="handleClearOrder(); $event.stopPropagation()"
						[text]="textClearOrderForm"
						hoverColor="var(--color__danger)"
						iconHoverColor="var(--color__white)"
						iconHoverQuerySelector="path"
						iconName="broom" />
				</div>
			</div>
			<div class="order-add-new__form">
				<div class="order-basic-info">
					<div class="order-basic-info__row form__element-12 form">
						<epic-form-field
							class="form__element-6"
							[text]="textConveyanceType">
							<epic-select
								[control]="orderForm.controls.conveyanceType"
								class="form__element-7">
								@for (type of conveyanceTypes; track type) {
								<epic-option
									[value]="type"
									[selected]="type.id === this.orderForm.controls.conveyanceType.value?.id"
									class="epic_select__option">
									{{ getItemTranslation(type) }}
								</epic-option>
								}
							</epic-select>
						</epic-form-field>
						<epic-form-field
							class="form__element-6"
							[class]="order? 'no-active': ''"
							[text]="textOrderTemplate">
							<epic-autocomplete
								[placeholder]="textSelect"
								[control]="orderForm.controls.template"
								(searchChange)="fetchTemplates($event)"
								[customSelectedValues]="true">
								<div
									*ngIf="orderForm.controls.template.value"
									class="epic-select__custom-values"
									selected-values>
									<span>{{ orderForm.controls.template.value.name }}</span>
								</div>
								@for (template of templates.items; track template) {
								<epic-option
									(click)="selectTemplate(template)"
									[value]="template"
									[selected]="template.id === this.orderForm.controls.template.value?.id"
									>{{ template.name }}
								</epic-option>
								}
							</epic-autocomplete>
						</epic-form-field>
					</div>
					<div class="order-basic-info__row form__element-12 form">
						<epic-form-field
							datePicker
							class="form__element-3"
							[text]="textDateAndTimeOfOrderAcceptance">
							<epic-input
								[control]="orderForm.controls['takeDate']"
								[placeholder]="textEnterDate" />
						</epic-form-field>
						<epic-form-field
							timePicker
							class="form__element-3">
							<epic-input
								[control]="orderForm.controls['takeTime']"
								[placeholder]="textEnterTime" />
						</epic-form-field>
						<epic-form-field
							class="form__element-6"
							[text]="textPriority">
							<epic-select
								[control]="orderForm.controls['priority']"
								class="form__element-7">
								@for (priority of priorities; track priority) {
								<epic-option
									[value]="priority"
									class="epic_select__option">
									{{ getItemTranslation(priority) }}
								</epic-option>
								}
							</epic-select>
						</epic-form-field>
					</div>
					<div class="form__element-12 is-carrier__container">
						<epic-checkbox
							[control]="orderForm.controls.is_carrier"
							(modelChange)="clearCarrierData($event)" />
						<label
							i18n
							(click)="orderForm.controls.is_carrier.patchValue(!orderForm.controls.is_carrier.value)">
							Add carrier data
						</label>
					</div>
					@if (orderForm.controls.is_carrier.value) {
					<div class="form__element-12 form">
						<div class="form__element-6 form">
							<div class="form__element-12">
								<epic-form-field [text]="textCarrierName">
									<epic-input
										[control]="orderForm.controls.carrier_name"
										[placeholder]="textCarrierNamePlaceholder" />
								</epic-form-field>
							</div>
							<div class="form__element-12">
								<epic-form-field [text]="textDriverName">
									<epic-input
										[control]="orderForm.controls.driver_name"
										[placeholder]="textDriverNamePlaceholder" />
								</epic-form-field>
							</div>
						</div>
						<div class="form__element-6 form">
							<epic-form-field
								class="form__element-12"
								[text]="textDriverData">
								<epic-textarea
									[control]="orderForm.controls.driver_data"
									[placeholder]="textDriverDataPlaceholder"
									[readOnly]="false"
									[rows]="7" />
							</epic-form-field>
						</div>
					</div>
					}
				</div>
				<ng-container *ngIf="true; then contractorFormTemplate" />
			</div>
		</div>
		<ng-container *ngIf="true; then containerFormTemplate" />
		<ng-container *ngIf="true; then terminalFormTemplate" />
		<ng-container *ngIf="true; then shipFormTemplate" />
		<ng-container *ngIf="true; then addressFormTemplate" />
		<ng-container *ngIf="true; then portFormTemplate" />
		<ng-container *ngIf="true; then returnsAddressFormTemplate" />
		<ng-container *ngIf="true; then additionalDataFormTemplate" />
	</div>
	<div class="order-add-new__btns">
		<epic-button
			[isConfirm]="true"
			(click)="submitForm()"
			size="large">
			<epic-icon name="add-order" />
			<span>{{ textAddOrder }}</span>
		</epic-button>
	</div>
</div>

<ng-template #contractorFormTemplate>
	@if(!orderForm.controls.entity.value?.id){
	<div class="order-add-new__contractor">
		<div class="order-select-contractor">
			<div class="choose-contractor__input">
				<epic-form-field [text]="textContractor">
					<epic-autocomplete
						class="form__element-7"
						[forceSelectingOptions]="true"
						(searchChange)="fetchEntities($event)"
						[control]="orderForm.controls['entity']"
						[customSelectedValues]="true">
						<div
							*ngIf="orderForm.controls['entity'].value"
							class="epic-select__custom-values"
							selected-values>
							<span>{{ orderForm.controls['entity'].value?.name }}</span>
						</div>
						@for (ent of entities?.items; track ent) {
						<epic-option
							*ngIf="!ent.is_blocked && !ent.contractor?.is_blocked && !checkContainerLimit(ent)"
							[selected]="ent.id === this.orderForm.controls.entity.value?.id"
							[text]="ent.name"
							[value]="ent" />
						} @for (ent of entities?.items; track ent) {
						<epic-option
							*ngIf="ent.is_blocked || ent.contractor?.is_blocked || checkContainerLimit(ent)"
							[text]="checkContainerLimit(ent)? ent.name + textLimitReached : ent.name + textBlocked"
							[selected]="ent.id === this.orderForm.controls.entity.value?.id && checkIfUserIsAdmin()"
							[value]="ent"
							[class]="checkIfUserIsAdmin()? '': 'no-active'" />
						}
					</epic-autocomplete>
					<epic-button
						[epic-tooltip]="textAddNewContractor"
						[epic-tooltip-classes]="['epic-tooltip--modal']"
						[id]="'orderFormAddNewContractorSubmit'"
						size="small"
						end
						[name]="textAddNewContractor"
						(click)="addingContractor = !addingContractor">
						<epic-icon name="add-user" />
					</epic-button>
				</epic-form-field>
			</div>
		</div>
		<div
			*ngIf="addingContractor"
			class="order-add-new__add_contractor">
			@if (isCreatingEntity) {
			<epic-loader-content animation="square" />
			} @else {
			<div class="font__heading-3 font-weight__semibold">{{ textAddContract }}</div>
			<contractor-form
				(createRequest)="createEntity()"
				#createContractorComponent />
			}
		</div>
	</div>
	} @else {
	<div class="column">
		<h5>{{ orderForm.controls.entity.value?.name }}</h5>
		<p class="font__small">
			{{ orderForm.controls.entity.value?.address?.street }} @if
			(orderForm.controls.entity.value?.address?.apartment_number) { {{
			orderForm.controls.entity.value?.address?.building_number }}/{{
			orderForm.controls.entity.value?.address?.apartment_number }} } @else { {{
			orderForm.controls.entity.value?.address?.building_number }} }
		</p>
		<p class="font__small">
			{{ orderForm.controls.entity.value?.address?.postal_code }}, {{ orderForm.controls.entity.value?.address?.city }},
			{{ orderForm.controls.entity.value?.address?.country?.toUpperCase() }}
		</p>
		@if (orderForm.controls.entity.value?.tax_identifier) {
		<p
			class="font__small"
			i18n>
			Tax Number: {{ orderForm.controls.entity.value?.tax_identifier }}
		</p>
		}
		<div class="margin__vertical--medium">
			<epic-button
				[text]="textDelete"
				size="small"
				classes="epic-button--danger-light"
				(onClick)="removeContractor()" />
		</div>
		<app-vies-validation
			[autoVerify]="true"
			(onChanges)="handleVIES($event)"
			[VATNumber]="getEntityVatNumber()"
			class="margin__bottom" />
		<app-eori-validation
			[autoVerify]="true"
			(onChanges)="handleEORI($event)"
			[EORI]="orderForm.controls.entity.value?.eori_number ?? undefined"
			class="margin__bottom" />
		@if (showContractorNameWarning()) {
		<div class="card card--warning font__small column margin__bottom">
			<div class="row align__center margin__bottom">
				<epic-icon name="warning" />
				<span
					class="margin__left--small font-weight__medium"
					i18n>
					Attention! The name returned by the EORI system does not match the contractor's details.
				</span>
			</div>
			<div>
				<span
					class="font-weight__medium"
					i18n
					>Current value:</span
				>
				<span class="margin__left--small"> {{ entity?.name }} </span>
			</div>
			<div>
				<span
					class="font-weight__medium"
					i18n
					>EORI return value:</span
				>
				<span class="margin__left--small"> {{ eoriResult?.name }} </span>
			</div>
		</div>
		} @if (showAddressesWarning()) {
		<div class="card card--warning font__small column">
			<div class="row align__center">
				<epic-icon name="warning" />
				<span
					class="margin__left--small font-weight__medium"
					i18n>
					Attention! The address returned by the EORI system does not match the contractor's details.
				</span>
			</div>

			@if (showCitiesWarning()) {
			<div
				i18n
				class="margin__top font-weight__medium">
				City
			</div>
			<div>
				<span
					class="font-weight__medium"
					i18n
					>Current value:</span
				>
				<span class="margin__left--small"> {{ entity?.address?.city }} </span>
			</div>
			<div>
				<span
					class="font-weight__medium"
					i18n
					>EORI return value:</span
				>
				<span class="margin__left--small"> {{ eoriResult?.city }} </span>
			</div>
			} @if (showStreetsWarning()) {
			<div
				i18n
				class="margin__top font-weight__medium">
				Street
			</div>
			<div>
				<span
					class="font-weight__medium"
					i18n
					>Current value:</span
				>
				<span class="margin__left--small"> {{ entity?.address?.street }} </span>
			</div>
			<div>
				<span
					class="font-weight__medium"
					i18n
					>EORI return value:</span
				>
				<span class="margin__left--small"> {{ eoriResult?.street }} </span>
			</div>
			} @if (showPostalCodesWarning()) {
			<div
				i18n
				class="margin__top font-weight__medium">
				Postal code
			</div>
			<div>
				<span
					class="font-weight__medium"
					i18n
					>Current value:</span
				>
				<span class="margin__left--small"> {{ entity?.address?.postal_code }} </span>
			</div>
			<div>
				<span
					class="font-weight__medium"
					i18n
					>EORI return value:</span
				>
				<span class="margin__left--small"> {{ eoriResult?.postal_code }} </span>
			</div>
			}
		</div>
		}
	</div>
	}
</ng-template>

<ng-template #containerFormTemplate>
	<div class="order-add-new__item">
		<div class="order-add-new__title">
			<div class="font__heading-3 font-weight__semibold">{{ textContainer }}</div>
		</div>
		<order-container-form
			[form]="orderForm"
			[order]="order" />
	</div>
</ng-template>

<ng-template #terminalFormTemplate>
	<div class="order-add-new__item">
		<div class="order-add-new__title">
			<div class="font__heading-3 font-weight__semibold">{{ textReceivingTerminal }}</div>
		</div>
		<div class="order-add-new__form">
			<div class="order-add-new__contractor">
				<div class="order-select-terminal">
					<div class="order-select-terminal__input">
						<epic-form-field>
							<epic-autocomplete
								[id]="'orderFormInputTerminal'"
								(searchChange)="fetchTerminal($event)"
								[forceSelectingOptions]="true"
								[control]="asFormControl(orderForm.controls['pickupTerminal'])"
								[placeholder]="textTypeAndSelect"
								[customSelectedValues]="true">
								<div
									*ngIf="orderForm.controls['pickupTerminal'].value"
									class="epic-select__custom-values"
									selected-values>
									<span>{{ getItemTranslation(orderForm.controls['pickupTerminal'].value) }}</span>
								</div>
								<epic-option
									*ngFor="let terminal of terminals.items"
									[value]="terminal"
									[selected]="terminal.id === orderForm.controls.pickupTerminal.value?.id"
									class="epic_select__option">
									{{ getItemTranslation(terminal) }}
								</epic-option>
							</epic-autocomplete>
							<epic-button
								[id]="'orderFormAddNewTerminalSubmit'"
								size="small"
								[epic-tooltip]="textAddNewTerminal"
								[epic-tooltip-classes]="['epic-tooltip--modal']"
								end
								[name]="textAddNewPickupTerminal"
								(click)="addingTerminal = !addingTerminal">
								<epic-icon name="add-relation" />
							</epic-button>
						</epic-form-field>
					</div>
				</div>
				<div
					*ngIf="addingTerminal"
					class="order-add-new__add_contractor">
					<div class="font__heading-3 font-weight__semibold">{{ textAddNewTerminal }}</div>
					@if (isCreatingTerminal) {
					<epic-loader-content animation="square" />
					} @else {
					<order-terminal-form
						(createRequest)="createTerminal()"
						#createTerminalComponent />
					}
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #shipFormTemplate>
	<div class="order-add-new__item">
		<div class="order-add-new__title">
			<div class="font__heading-3 font-weight__semibold">{{ textShip }}</div>
		</div>
	</div>
	<order-ship-form
		[form]="orderForm"
		[order]="order"
		#createShipComponent />
</ng-template>

<ng-template #portFormTemplate>
	<div class="order-add-new__item">
		<div class="order-add-new__title">
			<div class="font__heading-3 font-weight__semibold">{{ textLoadingPort }}</div>
		</div>
		<div class="order-add-new__form">
			<div class="order-add-new__contractor">
				<div class="order-loading-port">
					<div class="order-loading-port__input">
						<epic-form-field [text]="textLoadingPort">
							<epic-autocomplete
								[id]="'orderFormInputLoadingPort'"
								[control]="loadingPortControl"
								(searchChange)="filterPorts($event)"
								[placeholder]="textSelect"
								[customSelectedValues]="true">
								<div
									class="epic-select__custom-values"
									selected-values>
									<span>{{ getItemTranslation(loadingPortControl.value) }}</span>
								</div>
								<epic-option
									*ngFor="let port of filteredPorts"
									[value]="port"
									[selected]="port.id === loadingPortControl.value?.id"
									class="epic_select__option">
									{{ getItemTranslation(port) }}
								</epic-option>
							</epic-autocomplete>
							<epic-button
								[id]="'orderFormButtonLoadingPort'"
								[epic-tooltip]="textAddNewLoadingPort"
								[epic-tooltip-classes]="['epic-tooltip--modal']"
								size="small"
								end
								(click)="addLoadingPort = !addLoadingPort">
								<epic-icon name="harbor" />
							</epic-button>
						</epic-form-field>
					</div>
				</div>
				<div
					*ngIf="addLoadingPort"
					class="order-add-new__add_contractor">
					<div class="font__heading-3 font-weight__semibold">{{ textAddNewLoadingPort }}</div>
					@if (isCreatingPort) {
					<epic-loader-content animation="square" />
					} @else {
					<order-loading-port-form
						[form]="orderForm"
						#createLoadingPortComponent />
					<div class="submit-row">
						<epic-button
							[isConfirm]="true"
							(click)="createLoadingPort()"
							size="large">
							<epic-icon name="harbor" />
							<span i18n>Save loading port</span>
						</epic-button>
					</div>
					}
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #addressFormTemplate>
	<div class="order-add-new__item">
		<div class="order-add-new__title">
			<div class="font__heading-3 font-weight__semibold">{{ textDeliveryAddress }}</div>
		</div>
		<div class="order-add-new__form">
			<div class="order-add-new__contractor">
				<div class="order-select-delivery-address">
					<div class="order-select-delivery-address__input">
						<epic-form-field [text]="textDeliveryAddress">
							<epic-select
								[epic-tooltip]="!orderForm.controls.entity.value && !addingAddress ? textEmptyEntity : ''"
								[id]="'orderFormSelectDeliveryAddress'"
								[control]="deliveryAddressControl"
								[placeholder]="textTypeAndSelect">
								<epic-option
									*ngFor="let address of deliveryAddresses.items"
									[selected]="address.id == deliveryAddressControl.value?.id"
									[value]="address"
									class="epic_select__option">
									{{ address.building_number }} {{ address.street }}, {{ address.postal_code }} {{ address.city }}
								</epic-option>
							</epic-select>
							<epic-button
								[id]="'orderFormButtonDeliveryAddress'"
								[epic-tooltip]="!orderForm.controls.entity.value ? textEmptyEntity : textAddNewAddress"
								[epic-tooltip-classes]="['epic-tooltip--modal']"
								size="small"
								[isDisabled]="!orderForm.controls.entity.value"
								(click)="addingAddress = !addingAddress"
								end>
								<epic-icon name="pin-angle" />
							</epic-button>
						</epic-form-field>
					</div>
				</div>
				<div
					*ngIf="addingAddress"
					class="order-add-new__add_contractor">
					<div class="font__heading-3 font-weight__semibold">{{ textAddNewAddress }}</div>
					<order-delivery-address-form
						[form]="orderForm"
						#createDeliveryAddressComponent />
					<div class="submit-row">
						<epic-button
							[isConfirm]="true"
							(click)="createDeliveryAddress()"
							size="large">
							<epic-icon name="pin-angle" />
							<span i18n>Save delivery address</span>
						</epic-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #returnsAddressFormTemplate>
	<div class="order-add-new__item">
		<div class="order-add-new__title">
			<div class="font__heading-3 font-weight__semibold">
				<div class="order-add-new__contractor">{{ textReturnAddressForEmptyContainer }}</div>
			</div>
		</div>
		<div class="order-add-new__form">
			<div class="order-add-new__contractor">
				<div class="order-return-address">
					<div class="order-return-address__input">
						<epic-form-field [text]="textReturnAddress">
							<epic-select
								[epic-tooltip]="!orderForm.controls.pickupTerminal.value  && !addingReturnAddress  ? textEmptyTerminal : ''"
								[id]="'orderFormSelectReturnAddress'"
								[control]="returnAddressControl"
								[placeholder]="textTypeAndSelect"
								[customSelectedValues]="true">
								<div
									class="epic-select__custom-values"
									selected-values>
									@if (returnAddressControl.value?.pickup_terminal) {
									<span class="font-weight__bold">{{ returnAddressControl.value?.pickup_terminal?.name }}:</span>
									} @else {
									<span class="font-weight__bold"
										>{{ returnAddressControl.value?.address?.name }} {{ returnAddressControl.value?.address?.reference
										}}:</span
									>
									}{{ returnAddressControl.value?.address?.building_number || '' }} {{
									returnAddressControl.value?.address?.street || '' }} , {{
									returnAddressControl.value?.address?.postal_code || '' }} {{ returnAddressControl.value?.address?.city
									|| '' }}
								</div>
								@for (address of deliveryReturnAddresses; track $index) {
								<epic-option
									[value]="address"
									[epic-tooltip]="address.pickup_terminal ? textTerminalAddress: textReturnAddress"
									[epic-tooltip-position]="'left'"
									[selected]="address.address.id == returnAddressControl.value?.address?.id"
									class="epic_select__option">
									@if (address.pickup_terminal) {
									<span class="font-weight__bold">{{ address.pickup_terminal.name }}:</span>
									} @else {
									<span class="font-weight__bold">{{ address.address.name }} {{ address.address.reference }} :</span>
									} {{ address.address.building_number }} {{ address.address.street }} , {{ address.address.postal_code
									}} {{ address.address.city }}
								</epic-option>
								}
							</epic-select>
							<epic-button
								[id]="'orderFormButtonReturnAddress'"
								size="small"
								[epic-tooltip]="!orderForm.controls.pickupTerminal.value ? textEmptyTerminal : textAddAnEmptyContainerReturnAddress"
								[epic-tooltip-classes]="['epic-tooltip--modal']"
								(click)="addingReturnAddress = !addingReturnAddress"
								[isDisabled]="!orderForm.controls.pickupTerminal.value"
								end>
								<epic-icon name="pin-map" />
							</epic-button>
						</epic-form-field>
					</div>
				</div>
				<div
					*ngIf="addingReturnAddress"
					class="order-add-new__add_contractor">
					<div class="font__heading-3 font-weight__semibold">{{ textAddNewAddress }}</div>
					<order-delivery-address-form
						[form]="orderForm"
						#createReturnAddressComponent />
					<div class="submit-row">
						<epic-button
							[isConfirm]="true"
							(click)="createReturnAddress()"
							size="large">
							<epic-icon name="pin-map" />
							<span i18n>Save return address</span>
						</epic-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #additionalDataFormTemplate>
	<div class="order-add-new__item">
		<div class="order-add-new__title">
			<div class="font__heading-3 font-weight__semibold">{{ textAdditionalData }}</div>
		</div>
		<div class="order-add-new__form">
			<div class="order-additional-info">
				<div class="order-additional-info__row form__element-12 form">
					<epic-form-field
						class="form__element-6"
						[text]="textOrderAssignedTo">
						<epic-autocomplete
							[id]="'orderFormSelectOrderAssignedTo'"
							[forceSelectingOptions]="true"
							(searchChange)="fetchUsers($event)"
							[control]="orderForm.controls['assignedTo']">
							<epic-option
								*ngFor="let user of users.items"
								[selected]="user.id === orderForm.controls.assignedTo.value?.id"
								[value]="user">
								{{ user.first_name }} {{ user.last_name }} {{ user.email }}
							</epic-option>
						</epic-autocomplete>
					</epic-form-field>
					<epic-form-field class="form__element-6">
						<a>{{ textAssignToMe }}</a>
					</epic-form-field>
				</div>
				<div class="order-additional-info__row">
					<div class="cost-invoice form">
						<div class="form__element-12">
							<epic-file-picker
								(fileError)="fileErrorHandler($event)"
								(filesChanged)="sendFile($event)"
								[acceptedMimeTypes]="['application/pdf', 'image/jpeg', 'image/tiff', 'image/png', 'image/webp']">
								<div class="cost-invoice__file">
									<epic-icon name="add" />
								</div>
							</epic-file-picker>
						</div>
					</div>
					<div class="attachments">
						<ng-container *ngIf="orderForm.controls.attachments.value?.length">
							<div class="attachments__accepted">
								<span class="font__medium font-weight__medium attachments__label">{{ textAcceptedFiles }}</span>
								<div
									class="row attachments__row"
									*ngFor="let file of orderForm.controls.attachments.value">
									<span class="font__small font__medium attachments__text">{{ file.display_name }}</span>
									<epic-icon-button
										hoverColor="var(--color__black)"
										iconHoverColor="var(--color__white)"
										iconHoverQuerySelector="rect fill"
										iconName="cancel"
										(click)="removeAttachment(file)" />
									<div class="attachments__row-tags">
										<span *ngFor="let tag of file.tags">{{ getItemTranslation(tag) }}</span>
									</div>
								</div>
							</div>
						</ng-container>
						<span
							*ngIf="tempFiles.length"
							class="font__medium font-weight__medium attachments__label"
							>{{ textUnacceptedFiles }}</span
						>
						<div
							*ngFor="let file of tempFiles"
							class="row attachments__row">
							<span class="font__small font__medium attachments__text">{{ file.name }}</span>
							<epic-icon-button
								hoverColor="var(--color__black)"
								iconHoverColor="var(--color__white)"
								iconHoverQuerySelector="rect fill"
								iconName="cancel"
								(click)="removeFile(file)" />
							<epic-select
								[multiSelect]="true"
								[control]="file.tags">
								<epic-option
									[withCheckbox]="true"
									*ngFor="let tag of fileTags"
									[value]="tag">
									{{ getItemTranslation(tag) }}
								</epic-option>
							</epic-select>
							<epic-icon-button
								(click)="acceptAttachment(file)"
								[text]="textAddAttachment"
								tooltipTextColor="var(--color__white)"
								hoverColor="var(--color__primary)"
								iconName="circle-plus" />
						</div>
					</div>
				</div>
				<div class="order-additional-info__row form__element-12 form">
					<epic-form-field
						class="form__element-12"
						[text]="textComments">
						<epic-textarea
							[control]="asFormControl(orderForm.controls['comment'])"
							[readOnly]="false"
							[placeholder]="textCommentsForOrder"
							[rows]="5">
						</epic-textarea>
					</epic-form-field>
				</div>
			</div>
		</div>
	</div>
</ng-template>
}
